import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ButtonBase } from '@material-ui/core';
import { Logo } from '../../static/images';
import { PHONE_NUMBER, callPhone } from '../chat/chatLinks';
import tokens from '../theme/tokens';

// 배송조회 페이지 틀 — 얇은 머리(로고 · 고객센터 전화)와 한 줄 세로 열. 사이트 헤더·푸터·공지·실시간문의는 쓰지 않는다
const useStyles = makeStyles(() => ({
  root: {
    minHeight: '100vh',
    backgroundImage: 'linear-gradient(to bottom, #fef7f5 0%, #ffffff 320px)',
    fontFamily: tokens.font,
    color: tokens.text,
    WebkitFontSmoothing: 'antialiased',
  },
  bar: {
    position: 'sticky',
    top: 0,
    zIndex: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 56,
    padding: '0 16px',
    backgroundColor: 'rgba(255,255,255,0.86)',
    backdropFilter: 'saturate(180%) blur(10px)',
    borderBottom: `1px solid ${tokens.primaryLine}`,
  },
  inner: {
    width: '100%',
    maxWidth: 560,
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  logo: { display: 'block', height: 26, width: 'auto' },
  call: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    height: 34,
    padding: '0 12px 0 10px',
    borderRadius: 17,
    border: `1px solid ${tokens.primaryLine}`,
    backgroundColor: tokens.surface,
    color: tokens.primaryDark,
    fontSize: 13,
    fontWeight: 700,
    letterSpacing: -0.4,
    fontFamily: tokens.font,
    '& svg': { display: 'block' },
  },
  main: {
    width: '100%',
    maxWidth: 560,
    margin: '0 auto',
    padding: '16px 16px 48px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
}));

const PhoneIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8 9.8a16 16 0 0 0 6.2 6.2l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.5 2.7.7a2 2 0 0 1 1.7 2z" />
  </svg>
);

function TrackShell({ children }) {
  const cs = useStyles();
  return (
    <div className={cs.root}>
      <header className={cs.bar}>
        <div className={cs.inner}>
          <img className={cs.logo} src={Logo} alt="퀴노스" />
          <ButtonBase className={cs.call} onClick={callPhone} focusRipple={false}>
            <PhoneIcon />
            {PHONE_NUMBER.replace(/^02-/, '')}
          </ButtonBase>
        </div>
      </header>
      <main className={cs.main}>{children}</main>
    </div>
  );
}

export default TrackShell;
